import { render, staticRenderFns } from "./IntegrationCenter.vue?vue&type=template&id=19b2126f&scoped=true"
import script from "./IntegrationCenter.vue?vue&type=script&lang=js"
export * from "./IntegrationCenter.vue?vue&type=script&lang=js"
import style0 from "./IntegrationCenter.vue?vue&type=style&index=0&id=19b2126f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b2126f",
  null
  
)

export default component.exports